import plural from 'plural-ru';

/**
 * Получение количества кастингов вместе со склонением
 * @param castingsCount - количество кастингов
 */
export const getCastingDeclension = (castingsCount: number) =>
  plural(castingsCount, '%d кастинг', '%d кастинга', '%d кастингов');

/**
 * Получение количества проектов вместе со склонением
 * @param projectsCount - количество проектов
 */
export const getProjectsDeclension = (projectsCount: number) =>
  plural(projectsCount, '%d проект', '%d проекта', '%d проектов');

/**
 * Получение возраста вместе со склонением
 * @param age - возраст
 */
export const getAgeDeclension = (age: number) =>
  plural(age, '%d год', '%d года', '%d лет');

/**
 * Получение кол-ва отрывков вместе со склонением
 * @param excerptsCount - кол-во отрывков
 */
export const getExcerptsDeclension = (excerptsCount: number) =>
  plural(excerptsCount, '%d отрывка', '%d отрывков', '%d отрывков');

/**
 * Получение секунд вместе со склонением
 * @param seconds - секунды
 */
export const getSecondsDeclension = (seconds: number) =>
  plural(seconds, 'секунда', 'секунды', 'секунд');

/**
 * Получение названия сущностей в ед. и мн. числе
 * @param count - количество
 * @param singular - обычная форма
 * @param pluralForm - множественная
 */
export const getDeclension = (
  count: number,
  singular: string,
  pluralForm: string
) => {
  return plural(count > 0 ? count : 1, singular, pluralForm, pluralForm);
};

/**
 * Русское склонение по числу с тремя формами (обёртка над plural-ru)
 * @param n - число
 * @param one - форма для 1, 21, 31…
 * @param few - форма для 2–4, 22–24…
 * @param many - форма для 0, 5–20, 25–30…
 */
export const pluralize = (
  n: number,
  one: string,
  few: string,
  many: string
): string => plural(n, one, few, many);

/**
 * Получение количества параметров вместе со склонением
 * @param parametersCount - количество параметров
 */
export const getParametersDeclension = (parametersCount: number) =>
  plural(parametersCount, '%d параметр', '%d параметра', '%d параметров');

/**
 * Получение количества просмотров вместе со склонением
 * @param viewsCount - количество просмотров
 */
export const getViewsDeclension = (viewsCount: number) =>
  plural(viewsCount, '%d просмотр', '%d просмотра', '%d просмотров');
